import React from "react";

import { CategoryScreen, Screen } from "../../../utils/types";

export interface ScreenSummaryItemProps {
    screen: CategoryScreen;
    option: Screen | undefined;
}

export const ScreensSummaryItem = ({ screen, option }: ScreenSummaryItemProps) => {
    return (
        <div
            key={screen.screen_id}
            style={{
                display: "flex",
                gap: "8px",
                alignItems: "center",
                padding: "2px",
            }}
        >
            <b>{option ? option.name : "-"}</b>
            <>
                <div style={{ borderLeft: "1px solid #ccc", height: "1.5rem" }} />
                <span>
                    Column: <b>{screen.column_number}</b>
                </span>
                <div style={{ borderLeft: "1px solid #ccc", height: "1.5rem" }} />
                <span>
                    Order Nr: <b>{screen.order_number}</b>
                </span>
            </>
        </div>
    );
};
